import apiClient from '../config/api';

const subassemblyService = {
  /**
   * Get all subassemblies for the current tenant
   * @param {number} machineId - Optional machine ID to filter subassemblies
   * @returns {Promise} Array of subassemblies
   */
  getAllSubassemblies: async (machineId = null) => {
    const params = machineId ? { machineId } : {};
    const response = await apiClient.get('/subassembly', { params });
    return response.data;
  },

  /**
   * Get subassembly by ID
   * @param {number} subassemblyId - Subassembly ID
   * @returns {Promise} Subassembly details
   */
  getSubassemblyById: async (subassemblyId) => {
    const response = await apiClient.get(`/subassembly/${subassemblyId}`);
    return response.data;
  },

  /**
   * Create a new subassembly
   * @param {object} data - Subassembly data
   * @returns {Promise} Created subassembly
   */
  createSubassembly: async (data) => {
    const response = await apiClient.post('/subassembly', data);
    return response.data;
  },

  /**
   * Update subassembly
   * @param {number} subassemblyId - Subassembly ID
   * @param {object} data - Updated subassembly data
   * @returns {Promise} Updated subassembly
   */
  updateSubassembly: async (subassemblyId, data) => {
    const response = await apiClient.post(`/subassembly/update/${subassemblyId}`, data);
    return response.data;
  },

  /**
   * Delete subassembly
   * @param {number} subassemblyId - Subassembly ID
   * @returns {Promise} Deletion result
   */
  deleteSubassembly: async (subassemblyId) => {
    const response = await apiClient.post(`/subassembly/delete/${subassemblyId}`);
    return response.data;
  },
};

export default subassemblyService;
